"use client";

import { Label } from "@/components/ui/label";
import { useJobWizardStore } from "@/features/jobs/store/job-store";

/**
 * Read-only preview of the selected ATS job's description, shown on wizard
 * step 1 BELOW the Job Manager / Employer selects (import path only).
 */
export function AtsImportDescription() {
  const { form } = useJobWizardStore();

  if (!form.remoteJobId) return null;

  return (
    <div className="flex flex-col gap-0.5">
      <Label>Job Description</Label>
      <div className="rounded-lg border border-border bg-contrast/[0.02] p-3 max-h-[160px] overflow-y-auto">
        {form.description ? (
          <p className="text-sm text-contrast/80 leading-5 whitespace-pre-wrap">
            {form.description}
          </p>
        ) : (
          <p className="text-sm text-contrast/40 leading-5">
            This job has no description in your ATS.
          </p>
        )}
      </div>
      <p className="text-xs text-contrast/40 leading-4 mt-1">
        Imported from your ATS — this becomes the job description.
      </p>
    </div>
  );
}
